//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import makeAngularReactController from '@react-bridge/angular-react-widget';

import { closeConfirmModal } from 'app/bulk-actions/bulk-actions-actions/bulk-actions-actions';
import { BulkActionsAddToStreamModal } from 'app/bulk-actions/components/BulkActionsAddToStreamModal';
import { useBulkAddToStreamMutation } from 'app/bulk-actions/hooks/useBulkAddToStreamMutation';
import { BulkActionNames } from 'app/bulk-actions/model/BulkActionNames';
import { getBulkActionsConfirmationModal } from 'app/bulk-actions/selectors/bulk-actions-selector';

const BulkAddToStreamWrapped = () => {
  const isAddToStreamModalOpen =
    useSelector(getBulkActionsConfirmationModal) ===
    BulkActionNames.ADD_TO_STREAM;

  if (!isAddToStreamModalOpen) {
    return null;
  }

  return <BulkAddToStreamModalContainer />;
};

const BulkAddToStreamModalContainer = () => {
  const dispatch = useDispatch();
  const { isPending, mutate: addToStream } = useBulkAddToStreamMutation();

  const handleClose = () => dispatch(closeConfirmModal());

  const handleComplete = (collectionIds: string[]) => {
    addToStream(collectionIds, {
      onSuccess: handleClose,
    });
  };

  return (
    <BulkActionsAddToStreamModal
      isSubmitting={isPending}
      onCancel={handleClose}
      onComplete={handleComplete}
    />
  );
};

angular.module('curalate').component('bulkAddToStreamWrapped', {
  controller: makeAngularReactController(<BulkAddToStreamWrapped />),
});
